if (!customElements.get('icraft-welcome')) {
  customElements.define('icraft-welcome', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.key = 'icraft-welcome30-dismissed-v1';
      this.onClick = event => {
        if (event.target.closest('[data-welcome-close]')) this.dialog.close();
        else if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      };
      this.onClose = () => {
        document.documentElement.classList.remove('iw-modal-open');
        this.remember();
      };
      this.onShow = () => this.open();
      this.dialog.addEventListener('click', this.onClick);
      this.dialog.addEventListener('close', this.onClose);
      document.addEventListener('icraft:welcome-open', this.onShow);
      if (this.querySelector('[data-welcome-success],[data-welcome-error]')) {
        this.open();
        if (this.querySelector('[data-welcome-success]')) this.remember(365);
      } else if (this.dataset.auto === 'true' && !this.dismissed()) {
        this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay || 10) * 1000);
      }
    }
    dismissed() {
      try { return Number(localStorage.getItem(this.key) || 0) > Date.now(); } catch (_) { return false; }
    }
    remember(days = 7) {
      try {
        const until = Math.max(Number(localStorage.getItem(this.key) || 0), Date.now() + days * 86400000);
        localStorage.setItem(this.key, String(until));
      } catch (_) {}
    }
    tryOpen() {
      if (this.dismissed()) return;
      const anotherDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .drawer.is-open')].some(element => {
        const style = getComputedStyle(element);
        const box = element.getBoundingClientRect();
        return style.visibility !== 'hidden' && style.display !== 'none' && box.width > 0 && box.height > 0 && box.left < innerWidth && box.right > 0;
      });
      if (document.hidden || anotherDialog || document.activeElement?.matches('input,textarea,select')) {
        this.timer = setTimeout(() => this.tryOpen(), 3000);
        return;
      }
      this.open();
      this.remember();
    }
    open() {
      if (!this.dialog.open) {
        this.dialog.showModal();
        document.documentElement.classList.add('iw-modal-open');
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.dialog.removeEventListener('click', this.onClick);
      this.dialog.removeEventListener('close', this.onClose);
      document.removeEventListener('icraft:welcome-open', this.onShow);
      if (this.dialog.open) this.dialog.close();
      document.documentElement.classList.remove('iw-modal-open');
      this.ready = false;
    }
  });
}
